dmx.Formatters('object', {

    // keys():Array
    keys: function(object) {
        return Object.keys(object);
    },

    // values():Array
    values: function(object) {
        return Object.keys(object).map(function(key) {
            return object[key];
        });
    },

    // hasKey(key:String):Boolean
    hasKey: function(object, key) {
        return Object.keys(object).indexOf(key) !== -1;
    },

    // hasValue(value:Any):Boolean
    hasValue: function(object, value) {
        return Object.keys(object).map(function(key) {
            return object[key];
        }).indexOf(value) !== -1;
    },

    // default():Object
    default: function(object) {
        return object;
    }

});
